import React from 'react';
import { Link } from 'react-router-dom';
import techsicoHeaderLogo from '../images/techsico_header_logo_375.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useBreakpoints from '../hooks/useBreakPoint';
import ServiceCarousel, { slides } from '../components/ServiceCarousel';
import Partner from '../components/home/Partner';
import FirstStep from '../components/home/FirstStep';
import Gallery from '../components/home/Gallery';
import About from '../components/home/About';
// import Announcements from '../components/home/Announcements';
import Map from '../components/Map';
import Button from '../components/buttons_refactor/Button';

const techsicoHeadquartersCoordinates = { lat: 36.149429, lng: -95.913879 };
const centerCoordinates = {
  sm: { lat: 36.153, lng: -95.92888 },
  md: { lat: 36.153, lng: -95.9305 },
  lg: { lat: 36.153, lng: -95.934 },
  '2xl': { lat: 36.153, lng: -95.948 },
  '3xl': { lat: 36.153, lng: -95.948 },
};

const Home = () => {
  const { isMd, isLg, is2xl, is3xl } = useBreakpoints();
  const [isHomeLoaded, setIsHomeLoaded] = React.useState(false);

  return (
    <>
      <div className="h-screen flex flex-col">
        <header className="flex-grow flex bg-center bg-cover bg-no-repeat bg-blend-multiply bg-gray-500 bg-opacity-40 bg-home-banner-xs md:bg-home-banner-md h-124 md:h-72 lg:h-106 2xl:h-140 3xl:h-180">
          <div className="flex flex-col ml-4 mt-62 text-white md:text-lg md:ml-20 md:mt-16.5 lg:text-xl lg:mt-26.5 lg:ml-31 2xl:text-2xl 2xl:mt-38 2xl:ml-36.5 3xl:mt-44 3xl:ml-44">
            <img
              className={`w-32 md:w-31.5 lg:w-40.5 2xl:w-54 3xl:w-72 md:transition-translate transform duration-1000 animate-fadeInOpacity ${
                isHomeLoaded ? 'md:translate-x-0' : 'md:-translate-x-12'
              }`}
              onLoad={() => {
                setIsHomeLoaded(true);
              }}
              src={techsicoHeaderLogo}
              alt="Techsico Logo"
            />
            {/* Negative margin to line up enterprise with logo */}
            <h1
              className={`font-montserrat font-bold text-6xl leading-15 -ml-1 lg:-ml-2 lg:text-8xl 2xl:mt-2 2xl:text-9xl 3xl:text-10xl transition-translate transform duration-1000 animate-fadeInOpacity ${
                isHomeLoaded ? 'md:translate-x-0' : 'md:translate-x-12'
              }`}
            >
              Enterprise
            </h1>
            {/* <div className="mt-7.5">
              <Button tag="modal" appearance="secondary">
                Request A Quote
              </Button>
            </div> */}
          </div>
        </header>
        <ServiceCarousel
          slidesToShow={isLg ? 5 : isMd ? 4 : 2}
          height={
            is3xl
              ? 'h-88'
              : is2xl
              ? 'h-72'
              : isLg
              ? 'h-44'
              : isMd
              ? 'h-32'
              : 'h-42'
          }
        >
          {slides.map(
            ({
              id,
              title,
              icon,
              slug,
              iconClassName,
              bgOpacity,
              bgColor,
              bgImage,
            }) => (
              <Link
                to={`/services/${slug}`}
                key={id}
                className={`overflow-hidden
                  ${
                    is3xl
                      ? 'h-90'
                      : is2xl
                      ? 'h-72'
                      : isLg
                      ? 'h-44'
                      : isMd
                      ? 'h-33'
                      : 'h-43'
                  }`}
              >
                <div className="relative h-full">
                  <div
                    className={`absolute bg-center bg-cover bg-no-repeat bg-blend-multiply h-full w-full md:hover:scale-110 transition-all duration-500 ease-in-out transform ${bgColor} ${bgOpacity} ${
                      is3xl
                        ? `${bgImage['3xl']}`
                        : is2xl
                        ? `${bgImage['2xl']}`
                        : isLg
                        ? `${bgImage.lg}`
                        : isMd
                        ? `${bgImage.md}`
                        : `${bgImage.xs}`
                    }`}
                  />
                  <h2
                    className={`absolute text-white font-montserrat font-bold text-base leading-5 bottom-4 ${
                      is3xl
                        ? 'text-3.5xl leading-10 bottom-8 left-8'
                        : is2xl
                        ? 'text-2xl leading-7 bottom-7 left-6'
                        : isMd
                        ? 'left-6'
                        : 'left-3'
                    }`}
                  >
                    {title.split('\n').map((line, i) => (
                      <span key={i} className="block">
                        {line}
                      </span>
                    ))}
                  </h2>
                  <img
                    src={icon}
                    alt={title}
                    className={`${iconClassName} absolute top-4 ${
                      is3xl
                        ? 'top-8 left-8'
                        : is2xl
                        ? 'top-6 left-6'
                        : isMd
                        ? 'left-6'
                        : 'left-3'
                    }`}
                  />
                </div>
              </Link>
            ),
          )}
        </ServiceCarousel>
      </div>

      <About />
      <Gallery />
      {/* <Announcements /> */}
      {/* When Announcements is back, add 'bg-techsicoGray-200' to className of locations */}
      <div
        id="locations"
        className="flex flex-col px-5.5 pt-20 pb-22.5 md:flex-row md:px-12 md:pt-22.5 md:pb-24 lg:py-26.5 2xl:py-36 2xl:px-26 3xl:px-33 3xl:py-40"
      >
        <div className="flex items-center ">
          <div className="w-full h-47 md:h-44 md:w-83 md:mr-6 md:ml-9 lg:h-60 lg:w-113 lg:mr-12 lg:ml-15 2xl:h-81 2xl:w-204 2xl:mr-16 3xl:w-255 3xl:mr-22 3xl:ml-11 3xl:h-104">
            <Map
              center={
                is3xl
                  ? centerCoordinates['3xl']
                  : is2xl
                  ? centerCoordinates['2xl']
                  : isLg
                  ? centerCoordinates.lg
                  : isMd
                  ? centerCoordinates.md
                  : centerCoordinates.sm
              }
              zoom={13}
              scrollWheelZoom={false}
              markerCoordinates={techsicoHeadquartersCoordinates}
              popupContent="910 South <br /> Hudson Avenue"
              className="rounded-2xl"
            />
          </div>
        </div>
        <div className="flex items-center">
          <div className="mt-6 md:mt-0">
            <h2 className="mb-4 font-montserrat font-bold text-2xl leading-1.2em lg:text-4xl lg:leading-1.2em 2xl:text-5xl 2xl:leading-1.2em 3xl:text-6.3xl">
              Headquarters
            </h2>
            <address className="not-italic mb-4 font-montserrat leading-1.55em text-techsicoGray-400 lg:text-lg lg:mb-4 2xl:text-2xl 2xl:leading-1.55em 3xl:text-3.5xl 3xl:mb-6">
              910 South Hudson Ave
              <br />
              Tulsa, OK 74112
            </address>
            <a
              href="tel:+1-918-585-2347"
              className="block font-montserrat leading-1.55em text-techsicoGray-400 hover:underline mb-8 md:mb-6 lg:mb-8 2xl:text-2xl 3xl:text-3.5xl 3xl:mb-12"
            >
              918-585-2347
            </a>

            <Link to="/locations" tabIndex="-1">
              <Button>View Other Locations</Button>
            </Link>
          </div>
        </div>
      </div>
      <FirstStep>
        {/* <Button tag="modal" appearance="secondary">
          Request A Quote
        </Button> */}
      </FirstStep>
      <Partner />
    </>
  );
};

export default Home;
